import { __extends } from "tslib";
import { axCoerceString } from '@awayfl/avm2';
import { Event } from './Event';
var StatusEvent = /** @class */ (function (_super) {
    __extends(StatusEvent, _super);
    function StatusEvent(type, bubbles, cancelable, code, level) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (code === void 0) { code = ''; }
        if (level === void 0) { level = ''; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._code = axCoerceString(code);
        _this._level = axCoerceString(level);
        return _this;
    }
    Object.defineProperty(StatusEvent.prototype, "level", {
        get: function () {
            return this._level;
        },
        set: function (value) {
            this._level = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatusEvent.prototype, "code", {
        get: function () {
            return this._code;
        },
        set: function (value) {
            this._code = value;
        },
        enumerable: false,
        configurable: true
    });
    StatusEvent.prototype.clone = function () {
        return new StatusEvent(this._type, this._bubbles, this._cancelable, this._code, this._level);
    };
    StatusEvent.prototype.toString = function () {
        return this.formatToString('StatusEvent', 'type', 'bubbles', 'cancelable', 'eventPhase', 'code', 'level');
    };
    StatusEvent.classInitializer = null;
    StatusEvent.STATUS = 'status';
    return StatusEvent;
}(Event));
export { StatusEvent };
